import React, { FC } from 'react'
import { Stack, Typography } from '@mui/material'
import RainbowTextField from '@components/RainbowTextField/RainbowTextField'
import { sanitizeDecimalInput } from '@plug-core/utils/validationHelper'
import Button from '@components/Button'
import useCyclesApprove from '@plug-core/hooks/useCyclesApprove'
import { useTranslation } from 'react-i18next'
import { logger } from '@plug-core/logger'

interface Props {
  hideSelf: () => void
}

const ApproveCycles: FC<Props> = ({ hideSelf }) => {
  const { amount, setAmount, walletCyclesBalance, approve, error, approveLoading } =
    useCyclesApprove()

  const { t } = useTranslation()

  return (
    <Stack spacing={2}>
      <Typography variant="h6" textAlign="center">
        {t('common.approve')}
      </Typography>
      <RainbowTextField
        value={amount}
        onChange={(e) => {
          sanitizeDecimalInput(e.target.value, setAmount)
        }}
        endAdornment={
          <Stack direction="row" alignItems="center">
            <Typography>{walletCyclesBalance?.token.symbol}</Typography>
          </Stack>
        }
        autoFocus
      />
      <Button
        variant="rainbow"
        onClick={() =>
          approve()
            .then(() => hideSelf())
            .catch(logger.debug)
        }
        disabled={!!error}
        loading={approveLoading}
        fullWidth
      >
        {error || t('common.approve')}
      </Button>
    </Stack>
  )
}

export default ApproveCycles
